import { LocalUserConfigService } from './../../../hio-config/src/lib/local-user-config.service';
import { computed, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { LocalConfigService } from '@hio/config';
import { HioFilter, HioFilterSet, JAuthService, JServerService } from '@j/api';
import { hioJWT } from 'projects/j-api/src/lib/jwt';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, map, take, withLatestFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HioAccessService {
  public authKeys = new BehaviorSubject<{}>({});

  private server = inject(JServerService);
  private auth = inject(JAuthService);
  private config = inject(LocalConfigService);
  private userConfig = inject(LocalUserConfigService);

  public usedKeys: Array<string> | null = null;
  private process = computed<string[]>(() => 
    hioJWT.parse(this.auth.accesstoken()).scope.split(" ")
  );

  private ready$ = combineLatest([
    toObservable(this.auth.accesstoken).pipe(filter(v => !!v)),
    this.auth.mandant.pipe(filter(v => !!v))
  ]).pipe(map(([_,m]) => m), distinctUntilChanged())

  constructor() {
    this.auth.mandant.pipe(filter(v => !!v), take(1)).subscribe(v => {
      this.init();
    });
  }

  private async init() {
    this.authKeys.next([]);

    const keys = await this.config.loadAsync('AUTHKEYS_'+this.auth.mandant.value);
    if (keys) this.authKeys.next(keys);

    this.ready$.subscribe(() => {
      this.refresh();
    });
  }

  private async refresh() {
    let newVafIdArr = {};
    const cb = await this.server.search<string>('/user/right/search', { filterset: new HioFilterSet([new HioFilter('id', this.usedKeys, this.usedKeys != null, 'IN_ARRAY')])});
    if (!cb.error) {
      cb.data.entry.forEach( key => { newVafIdArr[key] = true; });
      this.authKeys.next(newVafIdArr);
      this.config.save('AUTHKEYS_'+this.auth.mandant.value, newVafIdArr);
    }
  }

  public check(authKey: string | string[]) {
    let ret = false;
    if (authKey == null) ret = true;
    if (typeof authKey == 'string' && authKey.toLowerCase() == 'user') ret = true;
    if (typeof authKey == 'string' && this.authKeys.value[authKey]) ret = true;
    let result = true;
    if (Array.isArray(authKey)) {
      authKey.forEach(e => {
        if (!this.authKeys.value[e])
          result = false;
      });
      ret = result;
    }
    return ret
  }

  
  public hasProcess(process: string ) {
    return this.process().includes(process);
  }
}
